<h1 mat-dialog-title>{{ 'Open Display Device' | translate }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <ix-select
      *ngIf="!isSingleDevice"
      formControlName="display_device"
      [label]="'Display Device' | translate"
      [options]="optionsDevice$"
      [tooltip]="'Pick a display device to open' | translate"
      [required]="true"
    ></ix-select>
  </form>
</div>
<div mat-dialog-actions class="buttons">
  <button
    mat-button
    ixTest="cancel"
    [matDialogClose]="false"
  >
    {{ 'Cancel' | translate }}
  </button>
  <button
    mat-button
    color="primary"
    ixTest="open"
    [disabled]="form.invalid"
    (click)="onOpen()"
  >
    {{ 'Open' | translate }}
  </button>
</div>
